import {
  DEFAULT_ERR,
  GET_APOB_SELLER_REQUEST,
  GET_APOB_SELLER_SUCCESS,
  GET_APOB_SELLER_FAILED,
} from '../types';
import API from '../../apiConfig';

import { setAlert } from './alert';

export const getApobSellerList = (parentId) => async (dispatch) => {
  dispatch({
    type: GET_APOB_SELLER_REQUEST,
  });
  API.get(`supplier/child_vendors?parentId=${parentId}`)
    .then((res) => {
      dispatch({
        type: GET_APOB_SELLER_SUCCESS,
        response: res.data,
      });
    })
    .catch((err) => {
      dispatch({
        type: GET_APOB_SELLER_FAILED,
        message: err.message,
      });
      dispatch(setAlert(err.message, 'error'));
    });
};
